<template>
  <page style="height: 100vh; overflow: hidden">
    <template v-if="isScan && cabinet && !isBtns">
      <div slot="nav" class="page-head-default" @click="isMenuView = true">
        <img src="../assets/imgs/menu.png" alt="" />
        {{ title }}
      </div>
    </template>
    <div class="home-warp" v-if="isScan && cabinet && !isBtns">
      <div class="banner" :style="banner"></div>
      <div class="home-warp-main">
        <div class="home-warp-block"></div>
        <div class="home-warp-cont">
          <div class="home-warp-title">
            <img src="../assets/imgs/map.png" alt="" />
            <span>{{ cabinet.shopname }}</span>
          </div>
          <div class="home-warp-jifei">
            <span>{{ cabinet.currencyName }}{{ cabinet.jifei }}</span
            >/{{ cabinet.jifeiDanwei }}{{ i18n.minute }}
          </div>
          <div class="home-warp-row">{{ shopDesc }}</div>
          <div class="home-warp-row">
            <img src="../assets/imgs/icon_phone.png" alt="" />
            {{ i18n.feature_1 }}
          </div>
          <div class="home-warp-row">
            <img src="../assets/imgs/icon_star.png" alt="" />
            {{ i18n.feature_2 }}
          </div>
          <!-- <div class="home-warp-row">
              <img src="../assets/imgs/icon_tag.png" alt="">
              {{i18n.feature_3}}
            </div> -->
        </div>

        <div class="home-warp-btn">
          <div
            class="btn"
            v-if="cabinet.yajintype === 0 && cabinet.yajin > 0"
            @click="onSubmit"
          >
            {{ i18n.preauth }} {{ cabinet.currencyName }}{{ amount }}
            {{ cabinet.currency }}
          </div>
          <div v-else class="btn" @click="onSubmit">
            {{ i18n.borrow }} {{ cabinet.currencyName }}{{ amount }}
            {{ cabinet.currency }}
          </div>
        </div>
        <!-- <div class="home-warp-btn" v-else>
            <div class="home-warp-tips">
              <img src="../assets/imgs/icon_info.png" alt="" />
              <span>{{ shopTips3 }}</span>
            </div>
            <!- <div class="btn" @click="onBorrow">{{ i18n.borrow }}</div> ->
          </div> -->
      </div>
    </div>
    <div v-else class="ucu-landing">
      <div class="ucu-logo-wrap">
        <img class="ucu-logo" src="../assets/imgs/ucu-logo.png" alt="U Charge Up" />
      </div>
      <div class="ucu-hero">
        <h1 class="ucu-title">Stay Connected.<br />Stay In The Moment.</h1>
        <p class="ucu-sub">
          Rent a portable charger and return it at any U&nbsp;Charge&nbsp;Up
          station near you.
        </p>
      </div>
      <div class="ucu-actions">
        <div v-if="code" class="ucu-btn" @click="onCode">Start renting</div>
        <template v-else>
          <div class="ucu-scan">
            <span class="ucu-scan-ic">📷</span>
            <span class="ucu-scan-t"
              >Scan the QR code on any cabinet to start renting</span
            >
          </div>
          <div class="ucu-btn" @click="onFindStation">
            📍&nbsp; Find a station near me
          </div>
        </template>
      </div>
      <div class="ucu-foot">
        <div class="ucu-foot-lbl">Prefer the app?</div>
        <DownloadStore></DownloadStore>
      </div>
    </div>

    <popup-warp v-model="isMenuView" dialogTransition="slide-left">
      <menu-side></menu-side>
    </popup-warp>
  </page>
</template>

<script>
import { mapState } from "vuex"
import { getMoble } from "../utils/index"
import { PopupWarp } from "../components/popup"
import { MenuSide } from "../components/menu"
import { QR_CODE, ZH_CODE, ORDER_TEMP } from "../apis/cabinet"
import { USER_CARD } from "../apis/user"
import { SAVED_CARD_TO_RENT } from "../apis/payment"
import DownloadStore from "../components/download/store.vue"
import userMixins from "../mixins/user"

export default {
  components: {
    MenuSide,
    PopupWarp,
    DownloadStore
  },
  mixins: [userMixins],
  computed: {
    ...mapState([
      "qrcode",
      "zhcode",
      "cabinet",
      "browser",
      "user",
      "system",
      "phone"
    ]),
    i18n() {
      return this.$t("home")
    },
    i18nMsg() {
      return this.$t("msg")
    },
    title() {
      return process.env.VUE_APP_NAME
    },
    code() {
      return this.qrcode || this.zhcode
    },
    scanUrl() {
      if (this.qrcode) {
        return `${QR_CODE}?id=${this.qrcode}`
      }
      if (this.zhcode) {
        return `${ZH_CODE}/${this.zhcode}`
      }
      return ""
    },
    banner() {
      return this.cabinet && this.cabinet.shoplogo
        ? `background-image: url(${this.cabinet.shoplogo});`
        : ""
    },
    shopDesc() {
      return `${this.i18n.price_info}`.format(this.cabinet)
    },
    shopTips1() {
      return `${this.i18n.tips_1}`.format(this.cabinet)
    },
    shopTips2() {
      return `${this.i18n.tips_2}`.format(this.cabinet)
    },
    shopTips3() {
      return `${this.i18n.tips_3}`.format(this.cabinet)
    },
    amount() {
      if (this.cabinet) {
        return (this.cabinet.yajin - this.cabinet.myyue).toFixed(2)
      } else {
        return 0
      }
    }
  },
  data() {
    const _this = this
    return {
      areaCode: "1",
      isMenuView: false,
      isScan: false,
      isBtns: false,
      checked: true,
      adVisible: false,
      swipeList: [
        {
          imgPath: require("../assets/imgs/step1.png"),
          title: _this.$t("home.swipetitle1"),
          text: _this.$t("home.swipemsg1")
        },
        {
          imgPath: require("../assets/imgs/step2.png"),
          title: _this.$t("home.swipetitle2"),
          text: _this.$t("home.swipemsg2")
        },
        {
          imgPath: require("../assets/imgs/step3.png"),
          title: _this.$t("home.swipetitle3"),
          text: _this.$t("home.swipemsg3")
        },
        {
          imgPath: require("../assets/imgs/step4.png"),
          title: _this.$t("home.swipetitle4"),
          text: _this.$t("home.swipemsg4")
        }
      ],
      cardList: [] // 支付的卡列表
    }
  },
  methods: {
    onScan() {
      if (!this.scanUrl) return
      this.$loading(true)
      this.$post(
        this.scanUrl,
        {},
        (resp) => {
          this.$loading(false)
          this.$store.commit("cabinet", {
            qrcode: this.code,
            ...resp
          })
          if (resp.zujieNum && resp.zujieNum > 0) {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: `${this.i18n.msg_rentcount}`.format(resp),
              confirmText: this.i18nMsg.vieworder,
              cancelText: this.i18nMsg.cancel
            })
              .then(() => {
                this.$router.push("/order")
                this.$store.commit("qrcode", "")
              })
              .catch(() => {
                this.$store.commit("qrcode", "")
              })
          } else {
            this.isScan = true
            this.isBtns = false
            this.adVisible = true
          }
        },
        (error) => {
          this.$loading(false)
          this.$toast(error)
        }
      )
    },
    async onSubmit() {
      if (!this.user) {
        return this.loadUser()
      }
      this.$store.commit("wallet", null)
      // yajin 押金金额  && overtimeAmount 超时金额
      const { yajin, overtimeAmount } = this.cabinet
      console.log(this.cabinet, yajin, overtimeAmount)
      // 余额租借 - 押金金额 = 0 && 超时金额 = 0
      if (yajin <= 0 && overtimeAmount <= 0) {
        return this.onBorrow()
      }

      let paymentWay = ""
      //  是否有卡
      var _isUserCard = this.cardList.length > 0
      // 卡授权 - 押金金额 = 0 && 超时金额 > 0
      if (yajin <= 0 && overtimeAmount > 0) {
        paymentWay = "PAYMENT_CARD"
        if (_isUserCard) {
          return this.saveToRent()
        }
      }
      // 预授权 - 押金金额 > 0 && 超时金额 > 0
      if (yajin > 0 && overtimeAmount > 0) {
        paymentWay = "PAYMENT_PROPAY"
        // 保存卡 - 押金金额 < 超时金额  （必须绑卡）
        if (yajin < overtimeAmount) {
          paymentWay = "PAYMENT_SAVED_PROPAY"
        }
      }
      this.$router.push({
        path: "/confirm",
        query: {
          paymentWay,
          payType: "YJ",
          price: this.amount,
          cabinetID: this.cabinet.cabinetID,
          yaJinType: this.cabinet.yajintype
        }
      })
    },
    onBorrow() {
      this.$loading(true)
      this.$get(
        // `${ORDER_TEMP}/${this.cabinet.qrcode}/paypal`,
        `${ORDER_TEMP}?qrcode=${this.cabinet.qrcode}`,
        {},
        (resp) => {
          this.$loading(false)
          console.log(resp)
          if (resp.data.outTradNo) {
            this.$router.push(
              `/result?tradeNo=${resp.data.outTradNo}&shopid=${this.cabinet.shopid}`
            )
          } else {
            this.$confirm({
              title: this.i18n.msg_fail_title,
              content: this.i18n.msg_fail_content,
              showCancel: false
            })
          }
        },
        (error) => {
          this.$loading(false)
          console.log(error)
          this.$toast(error)
        }
      )
    },
    onCode() {
      this.isBtns = false
      this.onScan()
    },
    onFindStation() {
      // open the nearby-stations map
      this.$router.push("/homeMap")
    },
    // 获取用户支付卡信息
    async getUserPayCard() {
      this.$loading(true)
      const qrcode = this.qrcode || (this.cabinet && this.cabinet.qrcode)
      if (!qrcode || !this.user) return
      const { data = [] } = await this.$Request("get", USER_CARD, {
        qrcode,
        orderId: "",
        agentld: this.agentOpenId
      })
      let cardList = []
      if (data && data.length) {
        cardList = data.map((item) => {
          return {
            phone: "all",
            label: item.pCardnumber,
            ...item.paymentConfig,
            ...item
          }
        })
        this.cardList = cardList
      }
      this.$loading(false)
      return cardList
    },
    saveToRent() {
      this.$loading(true)
      this.$get(
        `${SAVED_CARD_TO_RENT}`,
        {
          qrcode: this.cabinet.cabinetID || this.$route.query.qrcode
        },
        (resp) => {
          this.$loading(false)
          console.log(resp)
          if (resp.data && resp.data.out_trade_no) {
            this.$router.replace(
              `/result?&payMode=${this.payMode}&tradeNo=${resp.data.out_trade_no}`
            )
          }
        },
        (error) => {
          this.$loading(false)
          console.log(error)
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
    }
  },
  created() {
    console.log("类型", this.browser, "1")
    const { cabinetshow } = this.$route.query
    this.isBtns = true
    if (cabinetshow === "true") {
      this.isScan = true
      this.isBtns = false
      this.adVisible = true
    } else {
      setTimeout(() => {
        this.$loading(false)
      }, 100)
    }
  },
  async mounted() {
    // 客户需要自动登录
    if (!this.user && this.code) {
      if (!this.phone) {
        this.$store.commit("phone", getMoble(5))
        await this.onSendCode(this.phoneNum || this.phone)
      } else {
        await this.onSendCode(this.phoneNum || this.phone)
      }
      this.getUserPayCard()
    }
  }
}
</script>

<style lang="less">
/* ===== U Charge Up brand landing (no-cabinet / download screen) ===== */
.ucu-landing {
  height: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: 108px 56px 56px;
  background: #ffffff;
  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;

  .ucu-logo-wrap {
    text-align: center;
    .ucu-logo {
      width: 440px;
      max-width: 78%;
      height: auto;
    }
  }

  .ucu-hero {
    text-align: center;
    margin-top: 64px;
    .ucu-title {
      font-family: "Montserrat-SemiBold", "Montserrat", sans-serif;
      font-weight: 700;
      font-size: 52px;
      line-height: 1.22;
      letter-spacing: -0.5px;
      color: #111827;
      margin: 0;
    }
    .ucu-sub {
      font-size: 28px;
      line-height: 1.55;
      color: #6b7280;
      margin: 26px auto 0;
      max-width: 94%;
    }
  }

  .ucu-actions {
    margin-top: 58px;
  }
  .ucu-scan {
    display: flex;
    align-items: center;
    background: #eaf3f8;
    border: 2px solid #cfe2ee;
    border-radius: 26px;
    padding: 26px 28px;
    margin-bottom: 26px;
    .ucu-scan-ic {
      font-size: 40px;
      line-height: 1;
      margin-right: 22px;
    }
    .ucu-scan-t {
      font-size: 26px;
      font-weight: 600;
      line-height: 1.4;
      color: #1f3a4d;
    }
  }
  .ucu-btn {
    background: #3179a6;
    color: #ffffff;
    border-radius: 26px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: "Montserrat-SemiBold", "Montserrat", sans-serif;
    font-weight: 600;
    font-size: 32px;
    box-shadow: 0 12px 30px rgba(49, 121, 166, 0.32);
    cursor: pointer;
    user-select: none;
    &:active {
      background: #29688c;
    }
  }

  .ucu-foot {
    margin-top: auto;
    text-align: center;
    padding-top: 40px;
    .ucu-foot-lbl {
      font-size: 24px;
      color: #9ca3af;
      margin-bottom: 22px;
    }
    /* tame the app-store badges: smaller + side by side */
    .downloaddark {
      margin: 0 !important;
      .icondark {
        width: 100% !important;
        display: flex;
        flex-direction: row;
        justify-content: center;
        img {
          width: 47% !important;
          margin: 0 14px !important;
        }
        img:last-child {
          margin-top: 0 !important;
        }
      }
    }
  }
}

.home-head {
  width: 100%;
  font-size: 36px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  // margin: 20px 0 0;
  padding: 46px 60px;
  .home-logo {
    width: 300px;
  }
  &-title {
    p {
      text-align: end;
      margin: 10px 0;
    }
    &-small {
      font-family: "Montserrat-Medium";
      font-size: 24px;
      color: #171917;
    }
    &-big {
      font-family: "Montserrat-SemiBold";
      font-size: 36px;
      font-weight: 500;
      color: #000;
    }
  }
}
.home-warp {
  .banner {
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
    background-color: #fff;
    background: url("../assets/imgs/banner-home.jpg") no-repeat center;
    background-size: cover;
  }
  &-main {
    width: 100%;
    height: calc(100vh - 454px);
    position: fixed;
    bottom: 0;
    left: 0;
    background: #ffffff;
    border-radius: 40px 40px 0 0;
    box-shadow: 0 0 40px rgba(0, 0, 0, 0.1);
  }
  &-block {
    display: flex;
    justify-content: center;
    align-items: center;
    &::after {
      content: " ";
      height: 8px;
      width: 80px;
      margin: 20px;
      border-radius: 4px;
      background: #cccccc;
    }
  }
  &-cont {
    padding: 0 48px;
  }
  &-title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    img {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }
  }
  &-jifei {
    padding: 60px 0 20px;
    font-size: 36px;
    font-weight: 600;
    span {
      font-size: 60px;
    }
  }
  &-row {
    display: flex;
    font-size: 24px;
    line-height: 32px;
    justify-content: flex-start;
    align-items: center;
    padding: 8px 0;
    color: #999999;
    img {
      width: 28px;
      height: 28px;
      margin-right: 10px;
    }
  }
  &-btn {
    position: fixed;
    left: 48px;
    right: 48px;
    bottom: 48px;
    button {
      width: 100%;
      border: none;
      padding: 0;
      margin: 0;
    }
  }
  &-tips {
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 40px;
    font-size: 28px;
    color: #666666;
    padding: 20px 0;
    img {
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }
  }
}
.home-bg {
  width: 60%;
  display: block;
  margin: 0px auto;
  // height: 100vh;
}
.my-swipe .van-swipe-item {
  img {
    display: block;
    width: 65%;
    margin: 0 auto;
  }
  h3,
  h4 {
    text-align: center;
  }
}
.home-btns {
  width: 100%;
  display: flex;
  position: fixed;
  bottom: 40px;
  justify-content: center;
  flex-direction: row;
  text-align: center;
  z-index: -1;
  a {
    text-decoration: none;
    width: 30%;
    flex: 1;
    margin: 20px;
    background: #000000;
    color: #ffffff;
    padding: 20px 0;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }
  }
}
.downloaddark {
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  margin: 0 60px;
  .next {
    width: 60%;
    font-family: "DIN Condensed Bold";
    font-size: 66px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    background: #73d146;
    border-radius: 20px;
    padding: 16px 20px;
    margin-top: 32px;
    .text {
      // line-height: 64px;
      display: block;
    }
    img {
      width: 64px;
      height: 64px;
      margin-left: 20px;
      vertical-align: middle;
    }
  }
}
.go-code {
  text-align: center;
  color: #67c23a;
  text-decoration: underline;
  padding: 10px 0 30px;
}
.home-foot {
  position: fixed;
  top: 42vh;
  left: 0;
  right: 0;
  background-color: #fff;
  .nearby {
    position: absolute;
    bottom: 170px;
    right: 20px;
    color: #fff;
    text-decoration: underline;
    text-align: center;
  }
}
.borrow-wechat-zff {
  display: flex;
  justify-content: center;
  padding: 20px 0 4px;
  img {
    height: 34px;
  }
}
.home-checkbox {
  font-size: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 18px;
  .home-checkbox-text {
    color: #52ac7a;
  }
  input[type="checkbox"] {
    cursor: pointer;
    position: relative;
  }
  input[type="checkbox"]::after {
    position: absolute;
    top: 0;
    background-color: #fff;
    color: #fff;
    width: 28px;
    height: 28px;
    display: inline-block;
    visibility: visible;
    padding-left: 0px;
    text-align: center;
    content: " ";
    border-radius: 4px;
    box-sizing: border-box;
    border: 2px solid #ddd;
  }

  input[type="checkbox"]:checked::after {
    content: "";
    background-color: #52ac7a;
    border-color: #52ac7a;
    background-color: #52ac7a;
  }

  input[type="checkbox"]:checked::before {
    content: "";
    position: absolute;
    top: 2px;
    left: 10px;
    width: 6px;
    height: 16px;
    border: solid white;
    border-width: 0 4px 4px 0;
    transform: rotate(45deg);
    z-index: 1;
  }
}
.home-mine {
  width: 90px;
  height: 60px;
  line-height: 30px;
  padding: 15px 0;
  font-size: 28px;
  text-align: center;
  position: fixed;
  right: 40px;
  bottom: 350px;
  z-index: 99;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 0 8px 24px 0 rgba(52, 125, 255, 0.32);
  // img {
  //   width: 100%;
  //   height: 100%;
  //   border-radius: 50%;
  // }
}
</style>
